export const CONFIRM_GRID_HEADER_PX = 42;
export const CONFIRM_GRID_ROW_PX = 42;
export const CONFIRM_GRID_MAX_VISIBLE_ROWS = 8;
export const CONFIRM_GRID_FIXED_HEIGHT_PX =
  CONFIRM_GRID_HEADER_PX + CONFIRM_GRID_MAX_VISIBLE_ROWS * CONFIRM_GRID_ROW_PX;
